/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OfferAttachmentOut
 */
export interface OfferAttachmentOut {
    /**
     * 
     * @type {number}
     * @memberof OfferAttachmentOut
     */
    offerId: number;
    /**
     * 
     * @type {Date}
     * @memberof OfferAttachmentOut
     */
    modificationDate: Date;
    /**
     * 
     * @type {string}
     * @memberof OfferAttachmentOut
     */
    urlPath: string;
    /**
     * 
     * @type {number}
     * @memberof OfferAttachmentOut
     */
    attachmentId: number;
}

export function OfferAttachmentOutFromJSON(json: any): OfferAttachmentOut {
    return OfferAttachmentOutFromJSONTyped(json, false);
}

export function OfferAttachmentOutFromJSONTyped(json: any, ignoreDiscriminator: boolean): OfferAttachmentOut {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'offerId': json['offerId'],
        'modificationDate': (new Date(json['modificationDate'])),
        'urlPath': json['urlPath'],
        'attachmentId': json['attachmentId'],
    };
}

export function OfferAttachmentOutToJSON(value?: OfferAttachmentOut | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'offerId': value.offerId,
        'modificationDate': (value.modificationDate.toISOString()),
        'urlPath': value.urlPath,
        'attachmentId': value.attachmentId,
    };
}


